var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCzAal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.38 3.62L3 25.89V69h70V25.89L38.38 3.62zM69 65H7V28.1L38.35 8.37 69 28.08V65zM54.53 42h-3v-.42a4.23 4.23 0 015.08-3.65A4.34 4.34 0 0160 42.24V63h-3V42a1.24 1.24 0 00-2.47 0zM32 24h12a5 5 0 015 4.79V41a2.01 2.01 0 11-4 0V28h-2v33.12a2 2 0 01-2 2c-.217 0-.433-.033-.64-.1A2 2 0 0139 61V45h-2v16.12a2 2 0 11-4-.12V28h-2v13a2 2 0 01-4 0V29a5 5 0 015-5zm3.43-9.07a4 4 0 115.22 6.06 4 4 0 01-5.22-6.06z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/CZ_AAL.82c3aa07.svg";
export { SvgCzAal as ReactComponent };